import * as React from "react";

import { asString } from "common/components/component-helpers";
import { LOADING } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import { Label } from "../ui/deprecated/components";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const LabelMaterialRenderer: GlideFunctionalRenderer = p => {
    const { getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[text]] = useForceValueProducers(getValueProducers, force, ctx);
    if (text === LOADING) return <Label />;
    return <Label data-test="app-label">{asString(text)}</Label>;
};
